// extracted by mini-css-extract-plugin
module.exports = {"initiativeCardInfo":"InitiativeCardInfo_initiativeCardInfo__32VTP"};